module.exports = __webpack_public_path__ + "img/Rectangle 1212 (1)-compressed.d0d1826f.jpg";